import { IS_BRIDGE_TO_MEDICARE } from 'core/constants/environment'
import { FBM_NAME, BTM_NAME } from 'core/constants/products'
import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import { toString } from 'utils/pivot/product'
import store from 'utils/store/withMiddleware'
import storage from 'proxy-storage'
import isFixedPlan from 'utils/pivot/plan/isFixedPlan'
import { propAccessor } from '@hc-frontend/utils'

function saveToStorage(state: Pivot.State) {
  const { hcStorage, carriers, addonsByPlan, addonsExternalByPlan } = state
  const plan = state.plans[state.planId]

  if (plan) {
    // update plan selected
    const isBTM = isBTMPlan(plan)
    const isFBM = isFixedPlan(plan)

    hcStorage.pivotPlan = hcStorage.pivotPlan || {}
    hcStorage.pivotPlan.monthlyCost = state.prices.planNumber
    hcStorage.pivotPlan.fee = state.prices.subscriptionFeeNumber
    hcStorage.pivotPlan.deductible = plan.coreBenefits.deductible
    hcStorage.pivotPlan.coinsurance = isFBM ? '' : plan.coreBenefits.userCoinsurance + '%'
    hcStorage.pivotPlan.planId = plan.planId
    hcStorage.pivotPlan.planName = plan.planName
    hcStorage.pivotPlan.fullPlanName = state.planName
    hcStorage.pivotPlan.planType = toString(plan.productId)
    hcStorage.pivotPlan.carrier = carriers[plan.carrierId].name
    hcStorage.pivotPlan.product =
      IS_BRIDGE_TO_MEDICARE || isBTM ? BTM_NAME : isFBM ? FBM_NAME : 'Short Term'
    hcStorage.pivotPlan.moop = plan.coreBenefits.outOfPocketMax
    hcStorage.pivotPlan.total = state.prices.total
    hcStorage.pivotPlan.isPrepaid = state.typeOfPay !== 'monthly'
    hcStorage.pivotPlan.bigTotal = state.prices.bigTotal
    hcStorage.pivotPlan.networkProvider = plan.coreBenefits.networkProvider
    // update add-ons
    hcStorage.addOn = state.addOns
    hcStorage.addOnSelected = [
      state.plans[state.dentalPlanId],
      state.plans[state.visionPlanId],
      state.plans[state.latitudeId],
      state.plans[state.supplementalId]
    ].filter(Boolean)
  }

  hcStorage.addonsByPlan = addonsByPlan
  hcStorage.addonsExternalByPlan = addonsExternalByPlan

  if (state.ameritasPriorCoverage) {
    hcStorage.ameritasPriorCoverage = state.ameritasPriorCoverage
  }

  if (state.selectedPlans) {
    hcStorage.selectedPlans = state.selectedPlans
  }

  if (state.quoteKey) {
    hcStorage.quoteKey = state.quoteKey
  }

  // update filters
  hcStorage.policies = state.filters.policies
  hcStorage.period = state.filters.period
  hcStorage.periodDays = propAccessor(state, 'periodRange.days', state.filters.period)
  hcStorage.sdate = state.sDate
  hcStorage.endDate = state.endDate

  // update external plans selected
  hcStorage.externalPlanSelected = state.externalPlanSelected
  hcStorage.externalPlans = state.externalPlans
  hcStorage.selectedBenefitLevels = state.selectedBenefitLevels
  storage.setItem('hc', hcStorage)

  store.update({ hcStorage }, true)
}

export default saveToStorage
